export const api = {
	// domain: 'https://grow.actyper.com',
	// main: 'https://grow.actyper.com/api', //主域名
    domain: 'https://www.guanmini.com',
	main: 'https://www.guanmini.com/api', //主域名
    // domain: 'https://czc.guanmini.com',
	// main: 'https://czc.guanmini.com/api', //主域名
	login:'/api/Login/index',
    teacherInfo:'/api/login/get_teacher_info',
    userInfo:'/api/Login/getUserInfo',
    uidLogin:'/api/Login/getUserByToken',
    studentInfo:'/api/Login/getStudentInfo',
    studentList:'/api/student/index',
    createStudent:'/api/student/add',
    editStudent:'/api/student/update',
    delStudent:'/api/student/delete',
    delAlbum:'/api/Album/delete',
    studentAlbum:'/api/student/student_album',
    addPhoto:'/api/Oss/add',
    albumList:'/api/Album/index',
    editAlbum:'/api/album/update',
    createAlbum:'/api/album/add',
    albumPhoto:'/api/AlbumImg/index',
    getClassStudent:'/eldership/Student/getStudentList',
    searchAlbumPhoto:'/api/Distribution/search',
    albumAdd:'/api/AlbumImg/add',
    rmPhoto:'/api/Distribution/rm',
    dis_all:'/api/Distribution/dis_all',
    img_info:'/api/Distribution/img_info',
    dis_img:'/api/Distribution/dis_one',
    delPhoto:'/api/AlbumImg/delete_img',
    addStudentPhoto:'/api/AlbumImg/add_student',
    unbindPhoto:'/api/Distribution/rm',
    personalPhoto:'/api/Personal/index',
    delPersonalPhoto:'/api/Personal/delete',
    uploadPersonal:'/api/Personal/add',
    getFonts:"/api/Fonts/getFonts",
    studentPhoto:'/eldership/AlbumImg/index',
    removeBind:'/api/Distribution/rm',
    albumTime:'/api/AlbumImg/album_img_time',
    rmBindStudent:'/api/Distribution/rm',
    disOnes:'/api/Distribution/dis_ones',
    sendMsm:'/api/Login/sendSMS',
    checkCode:'/api/Login/validateMobile',
    changePwd:'/api/Login/changePassword',
    checkPwd:'/api/Login/validatePassword',
    changeMobile:'/api/Login/changeMobile',
    growPage:'/api/Cooperation/grow_page_num',
    parentCooperation:'/api/Parents/cooperation',
    growCooperation:'/api/Cooperation/grow_up_content',
    growupCooperation:'/api/Cooperation/grow_page_num',
    growPlateList:'/api/GrowUpContent/index',
    growupDetail:'/api/GrowUpContent/detail',
    //编辑器复制
    getBackground:'/admin/Background/getBackground',
    getPaster:'/admin/Paster/getPaster',
    getFrame:'/admin/Frame/getFrame',
    getBuiltUp:'/admin/BuiltUp/getBuiltUp',
    addBuiltUp:'/admin/BuiltUp/edit',
    buildUpDetail:'/admin/BuiltUp/detail',
    getPlateDetail:'/admin/Template/detail',
    addPlateContent:'/admin/TemplateContent/add',
    updatePlateContent:'/admin/TemplateContent/edit',
    getPlateRows:'/admin/TemplateContent/index',
    getPlatePageDetail:'/admin/TemplateContent/detail',
    delPlateContent:'/admin/TemplateContent/delete',
    albumAdd2:'/api/Oss/add',
    searchPlate:'/admin/TemplateContent/getTemplateList',
    copyPlate:'/admin/TemplateContent/copyTemplateContent',
    //
    getBackground2:'/api/GrowUpContent/getBackground',
    getPaster2:'/api/GrowUpContent/getPaster',
    getFrame2:'/api/GrowUpContent/getFrame',
    getBuiltUp2:'/api/GrowUpContent/getBuiltUp',
    getPhoto2:'/api/GrowUpContent/getPhoto',
    batchDel:'/api/GrowUpContent/batchDelElement',
    batchAdd:'/api/GrowUpContent/batchAddElement',
    batchEdit:'/api/GrowUpContent/batchEditElement',
    batchEditBg:'/api/GrowUpContent/batchEditBg',
    batchGetElement:'/api/GrowUpContent/batchGetElement',
    growPages:'/api/GrowUpContent/getContentList',
    //成长册
    submitGrowup:'/api/GrowUp/complete',
    classRecord:'/api/GrowUp/record',
    //家长端
    parentGetStudentPhotos:'/eldership/AlbumImg/index',
    parentGetStudentAlbum:'/eldership/Album/index',
    parentGetStudents:'/eldership/Student/index',
    parentUpload:'/eldership/AlbumImg/add',
    parentDelPhoto:'/eldership/AlbumImg/delete',
    claimPhoto:'/eldership/AlbumImg/claim',
    babyRecord:'/eldership/Cooperation/record',
    MyBabyList:'/eldership/Student/index',
    parentGrowupList:'/eldership/Cooperation/index',
    //消息
    newsList:'/api/Parents/get_message',
    newsCount:'/api/Parents/read_count',
    newsDetail:'/api/Parents/read_message',
    //家长端编辑
    parentgetBackground:'/eldership/Cooperation/getBackground',
    parentgetPaster:'/eldership/Cooperation/getPaster',
    parentgetFrame:'/eldership/Cooperation/getFrame',
    parentgetBuiltUp:'/eldership/Cooperation/getBuiltUp',
    addBuiltUp:'/admin/BuiltUp/edit',
    parentGetPhoto: '/eldership/Cooperation/getPhoto',
    parentGrowDetail:"/eldership/Cooperation/detail",
    parentEditGrowup:'/eldership/Cooperation/edit',
    parentDelElement:'/eldership/Cooperation/delElement',
    parentAddElement:'/eldership/Cooperation/add',
    parentContentList:'/eldership/Cooperation/getContentList',
    parentGrowupList2:'/eldership/Cooperation/growUp',
    replayElement:'/eldership/Cooperation/replayElement',
    growupList:"/eldership/Cooperation/growUp",
    getIsComplete:"/eldership/Cooperation/getIsComplete",
    downloadImgs:"/api/albumImg/downloadPhotos",
}
